module.exports = __webpack_public_path__ + "img/report@2x.c53d483.png";